<template>
  <div class="w-full flex justify-center items-center relative">
    <div
      v-if="!emailSubmitted"
      class="text-center w-full relative z-20 text-black bg-white"
    >
      <h3>Subscribe for regular updates</h3>
      <p>
        Enter your email address below to oppt in for emails containing the
        latest jobs, news and events from the Careers Department.
      </p>
      <div
        class="rounded-xl w-10/12 relative left-1/12 flex flex-wrap lg:flex-nowrap lg:space-x-4 lg:h-12 mt-8 bg-white"
      >
        <input
          id="subscribe_email"
          v-model="emailMenuInput"
          type="email"
          name="subscribe_email"
          placeholder="Enter your email"
          :class="inputClass"
          class="w-full my-2 lg:my-0"
          @keyup="checkValidation"
          @change="checkValidation"
        />
        <button
          :disabled="!canSubmit"
          :class="[
            !canSubmit && !thinking
              ? 'opacity-25 border border-truegray-700'
              : 'btn-primary',
            thinking ? 'thinking-primary btn-primary cursor-not-allowed' : '',
          ]"
          type="submit"
          class="btn active:bg-primary relative m-0 w-full lg:w-auto h-12 my-2 lg:my-0"
          @click="requestSubscriptionEmail"
        >
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie v-if="thinking" :options="loadingAnimationOptions" />
          </div>
          <span :class="[thinking ? 'invisible' : '']">Subscribe</span>
        </button>
      </div>
    </div>
    <div
      v-else
      class="text-center w-full lg:w-3/4 relative z-20 flex flex-col space-y-4 text-black"
    >
      <p>
        {{ subscribeResponse }}
        <span class="text-primary font-semibold">{{ emailSentTo }}</span
        >.
      </p>
      <button
        type="button"
        class="btn btn-primary"
        @click="resetSubscriptionForm"
      >
        Close
      </button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../js/plugins/event-bus.js'
import { shared } from '../../../../js/mixins/shared.js'
import * as loadingAnimation from '../../../../shared/components/loading.json'

export default {
  mixins: [shared],

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      thinking: false,

      emailSubmitted: false,
      emailMenuInput: '',
      canSubmit: false,
      inputClass:
        'flex justify-center items-center sm:text-sm text-black focus:text-black active:text-black focus:outline-none active:outline-none transition-all duration-100 ease-in-out border border-truegray-300 rounded bg-white px-4 h-12',
      subscribeResponse: '',
      emailSentTo: '',
    }
  },

  methods: {
    resetSubscriptionForm() {
      this.$set(this, 'emailMenuInput', '')
      this.$set(this, 'canSubmit', false)
      this.$set(this, 'emailSubmitted', false)
      this.$set(this, 'emailSentTo', '')
      EventBus.$emit('showModal', 'subscribe')
    },

    checkValidation() {
      let canSubmit = true
      if (!this.validateEmail(this.emailMenuInput)) {
        canSubmit = false
      }
      this.$set(this, 'canSubmit', canSubmit)
    },

    requestSubscriptionEmail() {
      if (!this.validateEmail(this.emailMenuInput)) {
        return
      }
      this.$set(this, 'thinking', true)
      axios
        .post('/api/request-subscription', { email: this.emailMenuInput })
        .then((response) => {
          this.$set(this, 'thinking', false)
          if (response.data.success) {
            this.$set(this, 'emailSentTo', this.emailMenuInput)
            let message =
              'To complete the process please verify your request by confirming your subscription through the email we sent to'
            if (response.data.no_action_taken) {
              message =
                'Thank you. Your email has been added to our subscription list.'
            }
            this.$set(this, 'subscribeResponse', message)
            this.$set(this, 'emailSubmitted', this.emailMenuInput)
          }
          this.$set(this, 'emailMenuInput', '')
          this.$set(this, 'canSubmit', false)
          if (response.data.alert) {
            EventBus.$emit('triggerAlertResponse', response.data.alert)
          }
        })
    },
  },
}
</script>

<style scoped>
.footer-subscribe::before {
  content: '';
  background: #000;
  opacity: 0.6;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
